<p-toast key="toastmsg"></p-toast>

<div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>RANKINGS </a>
</div>
<div class="topTitle">
    <h2>RANKINGS</h2>
</div>
<div class="container mx-auto aos-init aos-animate" data-aos="fade-up">
    <div class="row">
        <div class="col-md-12">
            <div class="mainPageTitle ">
                <div class="tab-div">
                    <ul class="tabList">
                        <li>
                            <button class="active-btn">
                                TPL Rankings
                            </button>
                        </li>
                        <li>
                            <button (click)="onDownloadClick('bottom')">
                                RTG Rankings
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container p-mobilenone">
    <main>
        <!-- ======= Product Section ======= -->
        <section class=" leader-baord-section">
            <div class="container aos-init aos-animate" data-aos="fade-up">
                <div class="row">
                    <div class="col-md-3  leftFilters-div">
                        <div class="filter-sidebar">
                            <div class="filter-header">
                                <span class="filter-title">Filters</span>
                                <a class="clear-filter" (click)="clear()">Clear filter</a>
                            </div>
                            <p-accordion [multiple]="true" class="filter-accordion" [activeIndex]="[0,0]">


                                <p-accordionTab header="Category">
                                    <div class="filterBody">
                                        <div class="filterHeader">
                                            <div class="searchbar">
                                                <input pInputText type="text" placeholder="Search for Category"
                                                    [(ngModel)]="searchedCategoryName" class="search-input"
                                                    (input)="onSearchCategory($event)" />
                                                <div class="icon">
                                                    <img src="../../../assets/images/tournament/filterSearch.svg"
                                                        alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="filterMainList">
                                            <div *ngFor="let categoryAndAgeGroup of categoryAndAgeGroupList; let i=index;"
                                                class="filterList">
                                                <p-radioButton name="categoryName" inputId="category{{i}}"
                                                    [(ngModel)]="selectedCategoryName" [value]="categoryAndAgeGroup"
                                                    (onClick)="onselectGetCategoryV2(categoryAndAgeGroup)"></p-radioButton>
                                                <label for="category{{i}}">{{ categoryAndAgeGroup?.categoryName
                                                    }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab>

                                <!-- <p-accordionTab header="Country">
                                    <div class="filterBody pt-2">
                                        <div class="filterHeader">
                                            <div class="searchbar">
                                                <input pInputText type="text" placeholder="Search for Country"
                                                    class="search-input" />
                                                <div class="icon">
                                                    <img src="../../../assets/images/tournament/filterSearch.svg"
                                                        alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="filterMainList">
                                            <div *ngFor="let country of countrylist" class="filterList">
                                                <p-checkbox [binary]="false"></p-checkbox>
                                                <label for="selectedAges">{{ country?.name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab> -->

                                <p-accordionTab header="State">
                                    <div class="filterBody pt-2">
                                        <div class="filterHeader">
                                            <div class="searchbar">
                                                <input pInputText type="text" placeholder="Search for State"
                                                    [(ngModel)]="searchedStateName" (input)="onSearchState($event)"
                                                    class="search-input" />
                                                <div class="icon">
                                                    <img src="../../../assets/images/tournament/filterSearch.svg"
                                                        alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="filterMainList">
                                            <div *ngFor="let state of statelist; let i=index;" class="filterList">
                                                <p-radioButton name="state" inputId="state{{i}}"
                                                    [(ngModel)]="selectedState" [value]="state"
                                                    (onClick)="onStateSelect(state)"></p-radioButton>
                                                <label for="state{{i}}">{{ state?.name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab>

                                <p-accordionTab header="City">
                                    <div class="filterBody">
                                        <div class="filterHeader">
                                            <div class="searchbar">
                                                <input pInputText type="text" placeholder="Search for City"
                                                    [(ngModel)]="searchedCityName" (input)="onSearchCity($event)"
                                                    class="search-input" />
                                                <div class="icon">
                                                    <img src="../../../assets/images/tournament/filterSearch.svg"
                                                        alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="filterMainList">
                                            <div *ngFor="let city of citylist; let i=index;" class="filterList">
                                                <p-radioButton name="city" inputId="city{{i}}"
                                                    [(ngModel)]="selectedCity" [value]="city"
                                                    (onClick)="onCitySelect(city)"></p-radioButton>
                                                <label for="city{{i}}">{{ city?.name }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab>

                                <!-- <p-accordionTab header="Month">
                <div class="filterBody">
                  <div class="filterMainList">
                    <div *ngFor="let  month of monthlist" class="filterList">
                      <p-checkbox [value]="month" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{month }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Date">
                <div class="filterBody dateRange">
                  <div class="filterMainList">
                    <div class="d-flex">
                      <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
                        dateFormat="dd/mm/yy" appendTo="body" placeholder="Select Date" (onSelect)="selectDateRange()">
                      </p-calendar>
                      <button pButton label="Clear" title="Clear" class="p-button p-ml-2 p-mb-0" style="color: #fff!important;
                    padding: 6px 0px;
                    width: 30%" (click)="clear()"></button>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Surface">
                <div class="filterBody">
                  <div class="filterHeader">
                    <div class="searchbar">
                      <input pInputText type="text" placeholder="Search for surface" [(ngModel)]="ageFilter"
                        class="search-input" />
                      <div class="icon">
                        <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="filterMainList">
                    <div *ngFor="let court of courtTypeList" class="filterList">
                      <p-checkbox [value]="court" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{ court.label }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab> -->
                            </p-accordion>

                            <!-- <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select State</h6>
                        </div>

                        <div class="sellers d-flex">
                            <p-dropdown inputId="state" [showClear]="true" [options]="states" placeholder="Select"
                                [filter]="true" (onChange)="setState($event)" optionLabel="name"
                                (onClear)="clearState()"></p-dropdown>
                         
                        </div>

                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select City</h6>
                        </div>


                        <div class="sellers d-flex">
                           
                            <p-dropdown inputId="city" [options]="cityList" [filter]="true" [showClear]="true"
                                placeholder="Select City" optionLabel="name" (onChange)="onCitySelect($event)"
                                (onClear)="clearCity()"></p-dropdown>
                         
                        </div>
                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Court</h6>
                        </div>
                        <div class="aminites available-section ">
                            <ul>
                                <li>
                                    <span> <p-checkbox binary="true" (onChange)="setHard($event)"></p-checkbox> </span>
                                    Hard/ Synthetic
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setGrass($event)"></p-checkbox> </span>
                                    Grass
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setClay($event)"></p-checkbox> </span>
                                    Clay
                                </li>
                            </ul>
                        </div>
                    </div> -->
                        </div>
                    </div>
                    <div class="col-md-9 find-partner-page">
                        <div class="searchTournament">
                            <div class="searchBar">
                                <input type="text" placeholder="Search Player"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')" />
                                <img src="../../../assets/images/tournament/search.svg" alt="" class="icon">
                            </div>
                            <div class="shortBtn">

                                <button>
                                    <div class="icon">
                                        <img src="../../../assets/images/tournament/sort.svg" alt="">
                                    </div>
                                    <div class="title">
                                        Sort
                                    </div>
                                </button>
                                <div class="shortBtn mobileFilters">
                                    <button (click)="showMobileFilter()">
                                        <div class="icon">
                                            <img src="../../../assets/images/tournament/Filter.svg" alt="">
                                        </div>
                                        <div class="title">
                                            FILTER
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>



                        <form [formGroup]="categoryForm" class="w-100 categoryForm">
                            <div class="titleDiv">
                                CATEGORIES
                            </div>
                            <ul class="formFilterList">
                                <li>
                                    <p-dropdown [style]="{'width':'260px'}" inputId="categoryType" appendTo="body"
                                        [options]="categoryAndAgeGroupList" formControlName="categoryType" [(ngModel)]="selectedCategoryName" 
                                        [filter]="true" placeholder="Select Category" optionLabel="categoryName"
                                        [showClear]="true" (onChange)="onselectGetCategoryV2($event)"></p-dropdown>
                                </li>
                            </ul>
                        </form>
                        <div class="rankingTable">
                            <p-table class="expandable" #dt [value]="tournamentResult" [paginator]="true" [rows]="10"
                                [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
                                (onLazyLoad)="loadLeaderboard($event)" [totalRecords]="totalRecords" [loading]="loading"
                                pageLinks="3" [showPageLinks]="true" [rowsPerPageOptions]="paginationOption"
                                styleClass="">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="Ranking-th rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1"
                                            rowspan="1" colspan="1" style="color: black;background-color: white;">
                                            <div>PLAYERS INFO</div>
                                        </th>

                                        <th class=" points-th  rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1"
                                            rowspan="1" colspan="1" style="color: black;background-color: white;">
                                            <div>POINTS</div>
                                        </th>
                                        <th class="act-button rin-dt-align-left sorting_disabled rin-dt-ellpsis-overflow-1"
                                            rowspan="1" colspan="1" style="color: black;background-color: white;">
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-result *ngIf="!showEmpty">

                                    <tr class="row_1">
                                        <td class="id-td Ranking-th">
                                            <div class="userDetials">
                                                <div class="rankNumbner normal">
                                                    {{result.rankPlayer }}
                                                </div>
                                                <div class="userMainDetails">
                                                    <div class="userImage">
                                                        <img src="../../../assets/img/ranking/userImage.jpg" alt="">
                                                    </div>
                                                    <div class="userName">
                                                        <p>{{result.fullName}}</p>
                                                        <span class="mobile-version city">Mumbai</span>
                                                    </div>
                                                </div>
                                            </div>

                                        </td>

                                        <td class="points-th ">
                                            <span class="mobile-lable">Points:</span>
                                            {{result.playerRanking}}
                                        </td>
                                        <td class="act-button ">
                                            <button (click)="showUserdetails(result.playerId)"
                                                class="btn btn-secondary Score-btn">
                                                Show Details
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7" style="background: #fff!important; box-shadow: none;">
                                            <div class="col-md-12 not-f-div">
                                                <div class="icon">
                                                    <i class='bx bx-search-alt'></i>
                                                </div>
                                                <p>
                                                    Please Select
                                                    Category and Age
                                                    Group.
                                                </p>
                                            </div>

                                        </td>
                                    </tr>
                                </ng-template>
                                <!-- <ng-template pTemplate="summary">
                                    <div class="p-d-flex p-ai-center p-jc-between">
                                        In total there are
                                        {{totalRecords }} Results.
                                    </div>
                                </ng-template> -->
                            </p-table>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </main>
</div>


<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


<p-dialog header="Filter" [(visible)]="filtervisible" [modal]="true" [style]="{ width: 'calc(100% - 30px)' }"
    [draggable]="false" [resizable]="false" id="filter-div">

    <form [formGroup]="categoryForm" class="w-100">
        <ul>
            <li>
                <p-dropdown [style]="{'width':'100%'}" inputId="categoryType" [options]="catList"
                    formControlName="categoryType" [filter]="true" placeholder="Select Category" optionLabel="label"
                    [showClear]="true" appendTo="body" (onChange)="onselectGetCategory($event)"></p-dropdown>
            </li>
            <li>
                <p-dropdown [autoDisplayFirst]="false" [style]="{'width':'100%'}" formControlName="ageGroup"
                    inputId="ageGroup" [options]="ageList" [filter]="true" placeholder="Select Age Group"
                    optionLabel="label" [showClear]="true" appendTo="body"
                    (onChange)="onAgeGroupSelect($event)"></p-dropdown>
            </li>
            <!-- <li>
                <p-dropdown appendTo="body" [style]="{'width':'100%'}" inputId="categoryType" [options]="categoryList"
                    formControlName="categoryType" [filter]="true" placeholder="Select Category"
                    optionLabel="matchTypeName" [showClear]="true" (onChange)="onSelectCategory($event)"></p-dropdown>
            </li>
            <li>
                <p-dropdown appendTo="body" [autoDisplayFirst]="false" [style]="{'width':'100%'}"
                    formControlName="ageGroup" inputId="ageGroup" [options]="ageGroupList" [filter]="true"
                    placeholder="Select Age Group" optionLabel="ageGroupName" [showClear]="true"
                    (onChange)="onAgeGroupSelect($event)"></p-dropdown>
            </li> -->
        </ul>

        <div class="col-md-12 p-p-0">
            <hr>
        </div>
        <ul>
            <li>
                <p-dropdown appendTo="body" [style]="{'width':'100%'}" inputId="state" [options]="statelist"
                    [showClear]="true" [filter]="true" (onChange)="onStateSelect($event)" placeholder="Select State"
                    optionLabel="name"></p-dropdown>
            </li>
            <li>
                <p-dropdown appendTo="body" [style]="{'width':'100%'}" inputId="city" [options]="citylist"
                    [showClear]="true" [filter]="true" placeholder="Select City" optionLabel="name"
                    (onChange)="onCitySelect($event)"></p-dropdown>
            </li>
        </ul>
    </form>

    <ng-template pTemplate="footer">
        <p-button (click)="filtervisible = false" label="Submit" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-dialog [closable]="true" [(visible)]="downloadModal" [style]="{width: '416px'}" id="downloadModalPopup"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" [closable]="false" [position]="position" [modal]="true">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>

<p-dialog id="mobileFilter" [(visible)]="mobilFilter" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
    [style]="{ width: '400px' }" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false">
    <ng-template pTemplate="header">
        <div class="filterHeader">
            <div class="title">
                <h6>Filters</h6>
            </div>
            <div class="close">
                <button pButton type="button" icon="pi pi-times" (click)="mobilFilter = false"></button>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="card filterTab">

            <p-tabView [(activeIndex)]="activeIndex">
                <p-tabPanel header="State">
                    <div class="filterBody pt-2">
                        <div class="filterHeader">
                            <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for State"
                                    [(ngModel)]="searchedStateName" (input)="onSearchState($event)"
                                    class="search-input" />
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="filterMainList">
                            <div *ngFor="let state of statelist; let i=index;" class="filterList">
                                <p-radioButton name="state" inputId="state{{i}}" [(ngModel)]="selectedState"
                                    [value]="state" (onClick)="onStateSelect(state)"></p-radioButton>
                                <label for="state{{i}}">{{ state?.name }}</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="City">
                    <div class="filterBody">
                        <div class="filterHeader">
                            <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for City"
                                    [(ngModel)]="searchedCityName" (input)="onSearchCity($event)"
                                    class="search-input" />
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="filterMainList">
                            <div *ngFor="let city of citylist; let i=index;" class="filterList">
                                <p-radioButton name="city" inputId="city{{i}}" [(ngModel)]="selectedCity" [value]="city"
                                    (onClick)="onCitySelect(city)"></p-radioButton>
                                <label for="city{{i}}">{{ city?.name }}</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <!-- <p-tabPanel header="Category">
                    <div class="filterBody">
                        <div class="filterHeader">
                            <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for Category"
                                    [(ngModel)]="searchedCategoryName" class="search-input"
                                    (input)="onSearchCategory($event)" />
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="filterMainList">
                            <div *ngFor="let categoryAndAgeGroup of categoryAndAgeGroupList; let i=index;"
                                class="filterList">
                                <p-radioButton name="categoryName" inputId="category{{i}}"
                                    [(ngModel)]="selectedCategoryName" [value]="categoryAndAgeGroup"
                                    (onClick)="onselectGetCategoryV2(categoryAndAgeGroup)"></p-radioButton>
                                <label for="category{{i}}">{{ categoryAndAgeGroup?.categoryName
                                    }}</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel> -->
                <!-- <p-tabPanel header="Academy">
          <div class="filterBody">
            <div class="titleTable">
              <h6>FILTER BY</h6>
            </div>
            <div class="filterMainList">
              <div *ngFor="let academy of academylist" class="filterList">
                <p-checkbox [value]="academy" [(ngModel)]="selectedAcademy" [binary]="false"
                  (onChange)="onAcademySelect($event)"></p-checkbox>
                <label for="selectedAges">{{ academy.name }}</label>
              </div>
            </div>
          </div>
        </p-tabPanel> -->
        <!-- <p-tabPanel header="Year">
          <div class="filterBody">
            <div class="titleTable">
              <h6>FILTER BY</h6>
            </div>
            <div class="filterMainList">
              <div *ngFor="let year of yearlist" class="filterList">
                <p-radioButton name="year" inputId="year{{i}}" [(ngModel)]="selectedCity" [value]="year" 
                (onClick)="onYearChange(year)"></p-radioButton>
                <label for="year{{i}}">{{ year.label }}</label>
              </div>
            </div>
          </div>
        </p-tabPanel>  -->
            </p-tabView>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="mainBtn">
            <div class="footerBtn">
                <button class="canelBtn" pButton type="button" label="CLEAR FILTER"
                    (click)="clear(); mobilFilter = false"></button>
                <button class="applyBtn" pButton type="button" label="APPLY" (click)="mobilFilter = false"></button>
            </div>
        </div>

    </ng-template>

</p-dialog>